export default __webpack_public_path__ + "static/media/1225.4d612cf7.png";